<template>
  <el-form
    size="small"
    label-position="top"
  >
    <el-row :gutter="15">
      <el-col
        :gutter="15"
        :md="18"
      >
        <el-row
          :gutter="15"
          :md="24"
          style="margin-bottom: 15px;"
        >
          <el-col
            :gutter="15"
            :md="12"
          >
            <el-card>
              <div
                slot="header"
                class="clearfix"
              >
                <span>Sender</span>
              </div>
              <Address :account-id="selectedAccount ? selectedAccount.id : account.id" />
            </el-card>
          </el-col>
          <el-col
            :gutter="15"
            :md="12"
          >
            <el-card>
              <div
                slot="header"
                class="clearfix"
              >
                <span>Receiver</span>
              </div>
              <Address :account-id="selectedAccount ? selectedAccount.id : account.id" />
            </el-card>
          </el-col>
        </el-row>
        <el-row
          :gutter="15"
          :md="24"
        >
          <el-card>
            <div
              slot="header"
              class="clearfix"
            >
              <span>Items</span>
              <el-button
                plain
                size="mini"
                style="float: right; padding: 3px 0"
                type="text"
                @click.native="items.push({})"
              >
                Add Item
              </el-button>
            </div>
            <div
              slot="footer"
              class="clearfix"
              style="height: 30px; position: 0px; background-color: red;"
            >
              <span>Totals:</span>
            </div>
            <template v-for="(item, index) in items">
              <Items
                :key="index"
                :item="item"
                :index="index"
                :item-types="itemtypes"
                :remove.sync="removeItem"
              />
            </template>
          </el-card>
        </el-row>
      </el-col>
      <el-col
        :gutter="15"
        :md="6"
      >
        <el-card>
          <div
            slot="header"
            class="clearfix"
          >
            <span>Details</span>
          </div>
          <div v-if="account && account.id === '5f5b377a-5343-4a68-9184-b560de4ea664'">
            <el-form-item
              label="Account"
              class="mb-2"
            >
              <el-autocomplete
                v-model="accountInput"
                :fetch-suggestions="accountQuerySearch"
                :trigger-on-focus="false"
                placeholder="Enter a keyword"
                class="w-100"
                :debounce="500"
                value-key="name"
                clearable
                @select="handleSelectAccount"
                @clear="clearAccountInput"
              />
            </el-form-item>

            <el-form-item
              label="Team"
              required
              class="mb-2"
            >
              <el-select
                v-model="team"
                placeholder="Select a team"
                class="w-100"
                value-key="id"
                filterable
                :loading="isLoadingTeams"
              >
                <el-option
                  v-for="teaml in teams"
                  :key="teaml.id"
                  :label="teaml.name"
                  :value="teaml"
                />
              </el-select>
            </el-form-item>
          </div>
          <Details />
        </el-card>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import Address from './Address'
import Details from './Details'
import Items from './Items'

export default {
  components: {
    Address,
    Details,
    Items
  },
  data () {
    return {
      team: null,
      account: null,
      accountInput: null,
      teams: [],
      isLoadingTeams: false,
      carriersAndServices: [],
      items: [{}],
      itemtypes: [],
      isLoadingItemtypes: false,
      selectedAccount: null
    }
  },
  created () {
    this.loadSession()
    this.loadItemTypes()
  },
  methods: {
    async loadSession () {
      this.account = (await this.$session.instance).account
    },
    async loadItemTypes () {
      this
        .$sdk
        .dictionary_itemtype
        .list(builder => {
          builder.page = 1
          builder.limit = 1000
          builder.order = 'uuid:asc'
        })
        .then(res => { this.itemtypes = res })
        .finally(() => { this.isLoadingItemtypes = false })
    },
    removeItem (index) {
      delete this.items[index]
    },
    accountQuerySearch (queryString, cb) {
      this
        .$sdk
        .account
        .list(builder => {
          builder.filters = { account_name: queryString, account_active: 1 }
          builder.include = [
            'carrier_service_settings.carrier_service.carrier',
            'carrier_service_settings.carrier_setting',
            'carrier_settings.carrier',
            'teams.shipper_setting.address'
          ]
        })
        .then(cb)
    },
    handleSelectAccount (account) {
      if (account instanceof this.$sdk.account) {
        this.accountInput = account.name
        this.teams = account.teams

        this.selectedAccount = account
        this.team = null

        this.carriersAndServices = {}

        // Array
        //   .from(
        //     new Set(
        //       this
        //         .$_
        //         .map(this.$_.get(account, 'carrier_service_settings', []), 'carrier_service.carrier.name')
        //     )
        //   )
        //   .map(carrier => {
        //     this
        //       .carriersAndServices[carrier] = this
        //         .$_
        //         .get(account, 'carrier_service_settings', [])
        //         .map(carrierServiceSetting => carrierServiceSetting.carrier_service.carrier.name === carrier && carrierServiceSetting.carrier_setting.carrier_active === true ? carrierServiceSetting.carrier_service : undefined)
        //         .filter(carrierService => typeof carrierService !== 'undefined')
        //   })

        if (this.teams.length === 1) {
          this.team = this.teams[0]
        }
      }
    },
    clearAccountInput () {
      this.accountInput = ''
      // this.account = null
      this.team = null
    }
  }
}
</script>
